var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraphsGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.81 123.52H55.72V134.64H67.81V123.52Z",
    fill: "#CDD9E2",
    stroke: "#CDD9E2",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M145.84 25L141.48 74.82C141.445 75.2285 141.329 75.626 141.14 75.9899C140.951 76.3537 140.693 76.6768 140.379 76.9405C140.065 77.2043 139.702 77.4036 139.311 77.527C138.92 77.6505 138.509 77.6957 138.1 77.66L93.7401 73.8C92.9142 73.7263 92.1513 73.328 91.6189 72.6924C91.0864 72.0568 90.8279 71.236 90.9001 70.41L95.9001 12.73C95.9763 11.9052 96.3753 11.1439 97.0103 10.6119C97.6452 10.08 98.4647 9.82051 99.2901 9.88997L136.29 13.13L145.84 25Z",
    fill: "#CDD9E2",
    stroke: "#CDD9E2",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0001 21.3699C33.6494 21.3738 26.465 23.5572 20.355 27.6439C14.2451 31.7306 9.48402 37.5371 6.67378 44.3294C3.86353 51.1217 3.1303 58.5947 4.56677 65.8036C6.00324 73.0126 9.54491 79.6338 14.744 84.8301C19.9431 90.0264 26.5662 93.5645 33.776 94.9971C40.9857 96.4297 48.4583 95.6925 55.2491 92.8786C62.0398 90.0647 67.8438 85.3005 71.9272 79.1883C76.0106 73.0762 78.1901 65.8906 78.1901 58.5399C78.1901 53.657 77.228 48.8219 75.3588 44.3109C73.4896 39.7999 70.7499 35.7015 67.2962 32.2496C63.8425 28.7978 59.7426 26.0603 55.2306 24.1935C50.7186 22.3267 45.883 21.3673 41.0001 21.3699ZM41.0001 80.3699C36.6734 80.3679 32.4444 79.0825 28.8484 76.6765C25.2523 74.2704 22.4508 70.8517 20.7982 66.853C19.1456 62.8542 18.7163 58.4552 19.5645 54.2124C20.4128 49.9696 22.5005 46.0738 25.5634 43.0178C28.6264 39.9618 32.527 37.883 36.7717 37.0445C41.0165 36.206 45.4145 36.6454 49.4095 38.3071C53.4044 39.9688 56.8167 42.7782 59.2145 46.3797C61.6124 49.9813 62.888 54.2131 62.8801 58.5399C62.8801 61.4123 62.314 64.2565 61.2142 66.91C60.1144 69.5634 58.5024 71.9742 56.4704 74.0043C54.4384 76.0345 52.0262 77.6442 49.3717 78.7416C46.7172 79.839 43.8725 80.4025 41.0001 80.3999V80.3699Z",
    fill: "#B4C5D0",
    stroke: "#B4C5D0",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.7 93.29H95.6101V134.63H107.7V93.29Z",
    fill: "#B4C5D0",
    stroke: "#B4C5D0",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136.618 28.3885L103.824 25.5193L101.726 49.4977L134.521 52.3669L136.618 28.3885Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0199 18.9299V58.5399L27.1799 95.0699",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 48.9099L41.7 59.2299",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.53 21.7L41.01 59.2299",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.47 140.12H133.09",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6699 134.63V105.38H87.7499V134.63",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M115.56 134.63V117.47H127.65V134.63",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M147.5 25.1699L135.52 24.1299L136.57 12.1499",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M100.77 57.5801L134.18 60.5001",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M100.29 63.0901L124.49 65.2101",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M105.58 44.91L114.59 37.81L119.99 43.71L130.06 35.71",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M131.86 34.1099L130.82 37.1499L128.7 34.6199L131.86 34.1099Z",
    fill: "#1F323D",
    stroke: "#1F323D",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphsGrey);
export default __webpack_public_path__ + "static/media/graphs_grey.c3bb09ff894c69f8b6a6418590b3ea9d.svg";
export { ForwardRef as ReactComponent };